module.exports = __webpack_public_path__ + "img/c.37e80f42.jpg";